<template>
  <BaseDialog max-width="800" persistent :value="true">
    <template #modal>
      <BaseCosmoCard v-if="docxTemplate">
        <template #title>
          <div class="modal_header">
            <BaseTitle v-text="$t('remove_docx_dialog.title')" />
            <BaseButtonIcon
              class="close_icon"
              icon="$mdiClose"
              @click="close()"
            />
          </div>
        </template>
        <div class="modal_content">
          <div
            v-if="!docxTemplate.isUsed"
            class="alert_danger"
            v-text="
              $t('remove_docx_dialog.confirmContent', {
                docName: $t(docxTemplate.name),
              })
            "
          />
          <template v-else>
            <div class="usage">
              <div
                class="usage_alert"
                v-text="
                  $t('remove_docx_dialog.alert', {
                    docName: docxTemplate.name,
                  })
                "
              />
              <ul>
                <li
                  v-for="(usage, index) in docxTemplate.usage.workflow"
                  :key="index"
                >
                  <router-link
                    :to="{
                      name: 'workflowDetail',
                      params: {
                        organizationId: organizationId,
                        workflowId: `${usage.id}`,
                      },
                    }"
                    tag="a"
                    class="usage_item"
                    v-text="usage.name"
                  />
                </li>
              </ul>
              <div
                class="confirm"
                v-text="$t('remove_docx_dialog.confirm_2')"
              />
            </div>
          </template>
        </div>
        <div class="modal_footer">
          <BaseButton
            :disabled="isSubmiting"
            color="grey"
            type="secondary"
            @click="close()"
          >
            {{ $t("utils.cancel") }}
          </BaseButton>
          <BaseButton
            :loading="isSubmiting"
            color="primary"
            type="primary"
            @click="remove()"
          >
            {{ $t("utils.delete") }}
          </BaseButton>
        </div>
      </BaseCosmoCard>
    </template>
  </BaseDialog>
</template>

<script>
import OrganizationAPI from "@/core/Services/organization.api";
import { DocxTemplate } from "@/core/Models/DocxTemplate";

export default {
  name: "DocxTemplateRemoveDialog",
  props: {
    docxTemplate: {
      type: DocxTemplate,
      default: () => null,
    },
    organizationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      isSubmiting: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async remove() {
      this.isSubmiting = true;
      try {
        await OrganizationAPI.deleteOrganizationDocxTemplate({
          organizationId: this.organizationId,
          docxTemplateId: this.docxTemplate.id,
        });
        this.$emit("docx-removed", this.docxTemplate);
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.snackbar.deleteSuccess"),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.isSubmiting = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  padding-top: 8px;
  flex-wrap: wrap;
  .modal_title {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #353542;
  }
  .close_icon {
    margin-left: auto;
  }
}
.modal_content {
  padding: 24px 0;
  .alert_danger {
    padding: 0 8px;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
    color: #ff5267;
  }
  .usage {
    font-family: "Inter";
    margin-bottom: 6px;
    font-size: 16px;
    line-height: 22px;
    .usage_alert {
      color: #353542;
      font-style: normal;
      margin-bottom: 6px;
    }

    .usage_item {
      text-decoration: underline;
      cursor: pointer;
      color: #2196f3;
      margin-bottom: 6px;
    }
    .confirm {
      margin-top: 12px;
      color: #ff5267;
    }
  }
}
.modal_footer {
  display: flex;
  justify-content: flex-end;
  align-content: center;
  padding: 8px 0;
  & > * {
    margin-left: 16px;
  }
}
</style>
